function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0-1h24v24H0z"
}), /*#__PURE__*/React.createElement("g", {
  transform: "rotate(90 11 12)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 16.5,
  cy: 3.5,
  r: 3.5,
  stroke: "currentcolor"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentcolor",
  d: "M10.466 6.601c-1.316.7-1.607.901-2.923 1.6l-.393.21c-.19.103-.396.223-.614.36-.219.138-.267.372-.144.704.148.278.51.392.792.242.83-.441 1.01-.573 1.839-1.015 1.312-.697 2.26-1.211 3.575-1.908l.91-.484c.27-.144.404-.52.242-.792-.161-.273-.503-.396-.792-.242l-2.492 1.325zm.19 8.912l-2.59-1.377-.392-.209c-.193-.1-.407-.203-.643-.308-.236-.104-.457-.013-.664.274a.595.595 0 0 0 .242.792c.83.442.975.539 1.805.98 1.312.698 1.961 1.023 3.274 1.723l.91.484c.27.144.656.044.792-.242s.047-.639-.242-.792l-2.492-1.325z"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 16.5,
  cy: 18.5,
  r: 3.5,
  stroke: "currentcolor"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 3.793,
  cy: 11.793,
  r: 3.793,
  stroke: "currentcolor"
})));

const SvgIcNetwork = (_ref) => {
  let {
    svgRef,
    title
  } = _ref,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 22,
    viewBox: "0 0 24 22",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIcNetwork, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ic-network.4da6e5ee.svg";
export { ForwardRef as ReactComponent };